// Lightweight GA4 event tracking helper.
// gtag is injected globally in src/routes/__root.tsx when a measurement ID is configured.
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function track(event: string, params: Record<string, any> = {}) {
  if (typeof window === "undefined") return;
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    } else {
      // Buffer to dataLayer in case gtag hasn't initialized yet.
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(["event", event, params]);
    }
  } catch {
    // no-op
  }
}
